import React from 'react';
import ReportDetails from '../ReportDetails';
import {
  REGULAR_ACTIVE_USERS_DESCRIPTION,
  REGULAR_ACTIVE_USERS_DESCRIPTION_FOR_MIXED_PLAN
} from '../../utils/resources/reports';

const ReportDetailsRegularUsers = props => <ReportDetails {...props} />;

ReportDetailsRegularUsers.defaultProps = {
  title: 'Regular Active Users',
  subtitle: 'last month',
  description: REGULAR_ACTIVE_USERS_DESCRIPTION,
  descriptionForMixedPlan: REGULAR_ACTIVE_USERS_DESCRIPTION_FOR_MIXED_PLAN,
  tabs: [
    {
      title: 'Active Users',
      selector: 'activeUserByMonth',
      csvFilename: 'regularActiveUsersByMonth',
      csvDescription:
        'This table shows monthly regular active users for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        users_regular: 'Regular Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'users_regular'
        }
      ]
    },
    {
      title: 'Active Users by Tenant',
      selector: 'activeUserByTenantMonth',
      csvFilename: 'regularActiveUsersByTenant',
      csvDescription:
        'This table shows monthly regular active users for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        tenant: 'Tenant',
        users_regular: 'Regular Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'users_regular'
        }
      ]
    }
  ],
  applianceTabs: [
    {
      title: 'Active Users',
      selector: 'activeUserByMonth',
      csvFilename: 'regularActiveApplianceUsersByMonth',
      csvDescription:
        'This table shows monthly regular active users for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        users_regular: 'Regular Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'users_regular'
        }
      ]
    },
    {
      title: 'Active Users by Private Instance',
      selector: 'activeUserByApplianceMonth',
      csvFilename: 'regularActiveApplianceUsersByAppliance',
      csvDescription:
        'This table shows monthly regular active users for each appliance for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        users_regular: 'Regular Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'users_regular'
        }
      ]
    },
    {
      title: 'Active Users by Tenant',
      selector: 'activeUserByAppplianceByTenantMonth',
      csvFilename: 'regularActiveApplianceUsersByTenant',
      csvDescription:
        'This table shows monthly regular active users for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        tenant: 'Tenant',
        users_regular: 'Regular Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'users_regular'
        }
      ]
    }
  ]
};

export default ReportDetailsRegularUsers;
